/* eslint-disable import/prefer-default-export */
import { useAuthStore } from '@stores/auth-store';
import { useShareStore } from '@stores/share-store';
import { useTenantAppStore } from '@stores/tenant-app-store';
import { useTenantShareStore } from '@stores/tenant-share-store';
import { useTenantStore } from '@stores/tenant-store';
import { useTenantParamStore } from '@stores/tenant-param-store';
import { useTenantUserStore } from '@stores/tenant-user-store';
import { useUserAppStore } from '@stores/user-app-store';
import { useUserStore } from '@stores/user-store';
import { useAutocompleteStore } from '@stores/autocomplete-store';
import { useViewStateStore } from '@stores/view-state-store';

export const resetTenantSpecificStores = () => {
  const tenantAppStore = useTenantAppStore();
  const tenantShareStore = useTenantShareStore();
  const tenantStore = useTenantStore();
  const tenantParamStore = useTenantParamStore();
  const tenantUserStore = useTenantUserStore();
  const autocompleteStore = useAutocompleteStore();
  const viewStateStore = useViewStateStore();

  tenantShareStore.$reset();
  tenantUserStore.$reset();
  tenantParamStore.$reset();
  tenantStore.$reset();
  autocompleteStore.$reset();
  tenantAppStore.$reset();
  viewStateStore.$reset();
};

// Do not reset toastStore to keep showing error messages.
// resetStores may be called by error.
export const resetStores = () => {
  resetTenantSpecificStores();

  const authStore = useAuthStore();
  const userAppStore = useUserAppStore();
  const userStore = useUserStore();
  const shareStore = useShareStore();

  shareStore.$reset();
  userStore.$reset();
  authStore.$reset();
  userAppStore.$reset();
};
